
/* LMM Technik-Ranking (Chris 2026-07-30) — EINE Quelle fuer Query-Normalisierung,
   strenge Kandidatenstufe und fachliche Trefferklassen. Wird sowohl vom
   Header-Dropdown (lmm-bestseller-sort-part-2/3) als auch von der vollstaendigen
   Suchseite (sections/lmm-search-results) benutzt, damit es KEINE zwei
   auseinanderdriftenden Gewichtungssysteme gibt.

   ANLASS (read-only am 2026-07-30 gemessen, www.leuchtmittelmarkt.com):
     q="16W/840"          ->  17 Treffer   (streng)
     q="16W/840 G13"      -> 605 Treffer   (Shopify weicht die Query auf)
   Ein ZUSAETZLICHER Term VERGROESSERT die Menge um Faktor 35. Dadurch standen
   58-W- und 140-W-Artikel in der Trefferliste, und die exakte 16-W-Roehre
   (SKU 1000112325) war auf Seite 1 gar nicht enthalten. Die beiden 7-W-LEDs
   ("ersetzt 16 W") lagen auf Platz 0 und 1.

   ZWEI GETRENNTE URSACHEN — beide hier adressiert:
     1) Kandidatenmenge: Shopifys Query-Aufweichung. Gegenmittel = die NATIVEN
        Attributfilter (belegt wirksam: specs.wattage, specs.color_code;
        specs.base ist KEIN aktiver Suchfilter — mit ihm bleibt die Menge
        unveraendert bei 605, exakt wie mit einem Unsinn-Parameter).
     2) Reihenfolge: der bisherige Reranker kannte ueberhaupt keine technische
        Genauigkeit — er sortierte nach Bestseller-Rang. specs.wattage=16,
        specs.replaces_wattage=16 und Titelbestandteile wie "7-16W" waren fuer
        ihn gleichwertig, weil keiner davon gelesen wurde.

   VERBINDLICHE REIHENFOLGE (Chris):
     technische Exaktheit > Titelgenauigkeit > Verfuegbarkeit > Popularitaet
   Popularitaet sortiert nur noch INNERHALB gleich genauer Treffer.

   KEINE SKU-SONDERREGEL. Es gibt keine Stelle, an der eine Artikelnummer,
   ein Produkt oder eine Wattstufe hart verdrahtet ist.

   ZWEITE RUNDE (Chris 2026-07-30, nach Sichtprüfung der Live-Suche):
     a) "Warum kommen Feuchtraumleuchten bei 16W/840 G13?" — Die Leuchte
        "… Submarine 600 2-flammig inkl. 2x8W/840 …" traegt specs.wattage=16,0
        (Summe aus 2 x 8 W) UND specs.base=G13 (sie nimmt G13-Roehren auf).
        Beide Attributpruefungen sagten deshalb "passt". Zwei neue Ausschluesse
        in classify() greifen genau hier: Titel-Wattwiderspruch und
        "Sockel in der Query heisst Leuchtmittel, nicht Leuchte".
     b) "Die 7-16W/840 muss doch auch kommen." — Richtig: sie ersetzt eine
        16-W-Roehre. Sie faellt nur deshalb heraus, weil die strenge Stufe auf
        specs.wattage filtert (dort steht 7,0). Dafuer gibt es jetzt
        ersatzFilterParams() als ausdrueckliche, nachgelagerte zweite Stufe. */
(function () {
  'use strict';
  if (window.LMMTechRank) return;

  /* ---------------------------------------------------------------- Normalisierung */
  /* Curated whole words only. Model/identifier tokens are never typo-corrected. */
  var TYPO_TOKEN_MAP = [
    [/\b(?:philis|phillips|philipps)\b/g, 'philips'],
    [/\b(?:ostam|osrsm|osrams|osran|osrm|osra)\b/g, 'osram'],
    [/\b(?:substuitube|substitub)\b/g, 'substitube'],
    [/\blumiux\b/g, 'lumilux'], [/\bleuchtstofflame\b/g, 'leuchtstofflampe'],
    [/\bleuchtmitrel\b/g, 'leuchtmittel'], [/\bkaltweis\b/g, 'kaltweiss']
  ];
  function typoNormalisieren(text) {
    if (/\b\d{6,}\b|\b(?:sku|ean|gtin|barcode|artikelnummer)\s*:/i.test(text)) return text;
    function wort(re, ziel) {
      text = text.replace(re, function (m, offset, all) {
        if (/[a-z0-9_.\/-]/i.test(all.charAt(offset - 1)) || /[a-z0-9_.\/-]/i.test(all.charAt(offset + m.length))) return m;
        return ziel;
      });
    }
    TYPO_TOKEN_MAP.forEach(function (paar) { wort(paar[0], paar[1]); });
    if (/\b(?:osram|s|d|l|t|f|el|longlife|g23|g24|2g11|gx24|w|watt)\b/.test(text)) wort(/\bdelux\b/g, 'dulux');
    if (!/\bb15d?\b|\bhalolux\b/.test(text)) wort(/\bgobe\b/g, 'globe');
    if (/\b(?:led|spot|strahler|lampe|leuchtmittel|osram|philips|par16)\b|\d+\s*w\b/.test(text)) wort(/\bfu10\b/g, 'gu10');
    return text;
  }

  function klein(v) {
    var s = String(v == null ? '' : v).replace(/[⁰¹²³⁴⁵⁶⁷⁸⁹₀₁₂₃₄₅₆₇₈₉]/g, function (c) {
      return String('⁰¹²³⁴⁵⁶⁷⁸⁹₀₁₂₃₄₅₆₇₈₉'.indexOf(c) % 10);
    }).toLowerCase();
    return s.replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss');
  }

  function zahl(v) {
    var n = Number(String(v).replace(',', '.'));
    return isFinite(n) ? n : null;
  }

  /* Lichtfarbcodes: erste Ziffer = Farbwiedergabe-Band, die beiden letzten x100 = Kelvin.
     Explizite Liste der real vorkommenden Endungen statt \d\d — sonst faellt 865 durchs
     Raster (endet auf 5) und "800 Lumen" wuerde faelschlich als Lichtfarbe gelesen.
     Deckungsgleich mit lmm-bestseller-sort-part-3. */
  var FARB = '[89](?:2[257]|3[035]|40|5[07]|6[05])';
  var RE_FARB = new RegExp('(?:^|[^0-9])(' + FARB + ')(?:$|[^0-9])');

  /* Sockelbezeichnungen, laengste zuerst — sonst schluckt "g5" das "gu5.3". */
  var SOCKEL = [
    '2gx13', 'gx24q', 'gx24d', 'g24q', 'g24d', 'gy6.35', 'gy635', 'gy9.5', 'gx5.3', 'gx10', 'gu5.3', 'gu53',
    '2g11', '2g10', '2g7', 'gr10q', 'p14.5s', 'px26d', 'ba15d', 'ba15s', 'gu10', 'g10q', 'gx53',
    'gz10', 'b22d', 's14s', 's14d', 'e14', 'e27', 'e40', 'r7s', 'g13', 'g23',
    'g53', 'gr8', 'g12', 'gu4', 'g4', 'g5', 'g9'
  ];

  function sockelRegex(sockel) {
    var kern = String(sockel).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp('(?:^|[^a-z0-9])' + kern + '(?:$|[^0-9])');
  }

  /* Kanonische Sockelform (Korrekturrunde 4, Chris Phase 4): Schreibvarianten
     derselben Bezeichnung fallen auf EINE Form zusammen — "GU 5,3", "gu5.3"
     und "gu53" sind derselbe Sockel. NUR diese kuratierten Paare; es gibt
     keine unscharfe Naeherung (G9 ist nicht GU5.3, nicht G23, nicht G24). */
  var SOCKEL_KANON = { 'gu53': 'gu5.3', 'gy635': 'gy6.35', 'gy95': 'gy9.5', 'p145s': 'p14.5s' };

  function kanonSockel(sockel) {
    var s = klein(sockel).replace(/\s+/g, '');
    return SOCKEL_KANON[s] || s;
  }

  /* G24-/GX24-Sockel tragen eine STUFENNUMMER (Stiftabstand je Wattklasse):
     G24q-3 ist NICHT G24q-2 — die Lampe passt mechanisch nicht in die
     Fassung. Nennt die Query eine Stufe, wird sie exakt verglichen; ohne
     Stufe bleibt es eine Familiensuche ueber alle Stufen (Korrekturrunde 4,
     belegt 05.08.2026: "G24q-3 18W" zeigte G24q-2-Lampen). */
  var SOCKEL_MIT_STUFE = /^(?:g24d|g24q|gx24d|gx24q)$/;

  function findeSockel(text, explicitOnly) {
    text = zerlege(text).text;
    for (var i = 0; i < SOCKEL.length; i++) {
      if (!sockelRegex(SOCKEL[i]).test(text)) continue;
      var kanon = kanonSockel(SOCKEL[i]);
      if (SOCKEL_MIT_STUFE.test(kanon)) {
        var kern = kanon.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        var fein = new RegExp('(?:^|[^a-z0-9])' + kern + '\\s*-?\\s*([1-6])(?:$|[^0-9])').exec(text);
        if (fein) return kanon + '-' + fein[1];
      }
      return kanon;
    }
    if (explicitOnly || /\b(?:treiber|trafos?|drivers?|netzteile?|adapter|fassung)\b/.test(text)) return null;
    if (/\bpar16\b/.test(text)) return 'gu10';
    if (/\bmr16\b/.test(text) && !/\b(?:cdm\w*|mastercolour|hqi|hid|24\s*v)\b/.test(text)) return 'gu5.3';
    if (/\bmr11\b/.test(text)) return 'gu4';
    if (/\bar111\b/.test(text)) return 'g53';
    return null;
  }

  /* Enthaelt ein Text (Titel oder strukturiertes Sockelfeld) den gesuchten
     Sockel EXAKT? Geprueft werden die kanonische, die punkt- und die
     bindestrichfreie Schreibweise mit Wortgrenzen — "g9" trifft nie als Teil
     von "gu10", und eine Feinstufe ("g24q-3") trifft nur ihre eigene Stufe. */
  function sockelImText(sockel, text) {
    var kanon = kanonSockel(sockel);
    var t = klein(text);
    var fein = /^(g24d|g24q|gx24d|gx24q)-([1-6])$/.exec(kanon);
    if (fein) {
      return new RegExp('(?:^|[^a-z0-9])' + fein[1] + '\\s*-?\\s*' + fein[2] + '(?:$|[^0-9])').test(t);
    }
    if (sockelRegex(kanon).test(t)) return true;
    var kompakt = kanon.replace(/[.\-]/g, '');
    if (kompakt !== kanon && sockelRegex(kompakt).test(t)) return true;
    return false;
  }

  /* Ersatz-/Umruest-Absicht. NUR ausdrueckliche Woerter — eine Serienbezeichnung
     wie "SubstiTUBE" zaehlt NICHT als Ersatzabsicht, sonst kippt jede Markensuche.
     Zwei Stufen, weil "led" schwaecher ist als "ersetzt":
       stark  = ausdrueckliches Ersatzwort. Reicht zusammen mit einer Wattangabe
                aus, um die Anfrage als strukturiert zu behandeln ("ersetzt 16W").
       schwach= zusaetzlich "led". Hebt Ersatztreffer im Ranking, macht aber aus
                "LED 16W" keine Ersatzsuche — das ist eine 16-W-LED. */
  var RE_ERSATZ_STARK = /\bersatz\w*\b|\bersetzt\b|\bersetzen\b|\balternativ\w*\b|\bumruest\w*\b|\bstatt\b|\banstelle\b|\bentspricht\b|\bumbau\b|\bretrofit\b|\baustausch\w*\b|\btausch\w*\b/;
  var RE_ERSATZ = new RegExp('\\bled\\b|' + RE_ERSATZ_STARK.source);

  /* Sucht die Query ausdruecklich eine komplette LEUCHTE? Nur dann duerfen
     Leuchten vorn stehen (siehe Ausschluss 2 in classify). "leuchtmittel" und
     "leuchtstoffroehre" fallen bewusst NICHT darunter — deshalb steht hinter
     "leuchte" eine Wortgrenze bzw. ein n. */
  var RE_LEUCHTE_QUERY = /\bleuchten?\b|\bfeuchtraum\w*\b|\bwannenleuchte\w*\b|\bbalkenleuchte\w*\b|\blichtband\w*\b|\bstrahler\b|\bdownlight\w*\b|\bpanel\w*\b|\bspiegelschrank\w*\b/;

  /* Wattstufe der Query: eine einzelne, ausdrueckliche Wattangabe. Ein Bereich
     ("7-16W") in der QUERY ist unklar und wird bewusst nicht als exakte Stufe
     gelesen — dann bleibt watt leer und es wird kein Wattfilter gesetzt. */
  var RE_QWATT = /(?:^|[^0-9.,\-])(\d{1,3}(?:[.,]\d)?)\s*w(?:att)?(?:$|[^a-z0-9])/;
  var RE_QBEREICH = /(?:^|[^0-9.,])(\d{1,3}(?:[.,]\d)?)\s*-\s*(\d{1,3}(?:[.,]\d)?)\s*w/;

  /* Farbtemperatur der Query (Korrekturrunde 3, Chris Phase 4). Nur eine
     ausdrueckliche vierstellige Kelvinangabe ("2700K", "2700 K", "2700 Kelvin");
     die Tausenderschreibweise "2.700 K" wird VOR dem Lesen zusammengezogen.
     Exakte Werte bleiben getrennt — es gibt keine Naeherung auf Nachbarwerte. */
  var RE_QKELVIN = /(?:^|[^0-9.,])([1-9]\d{3})\s*k(?:elvin)?(?:$|[^a-z0-9])/;
  /* Lichtstrom der Query ("180lm", "180 Lumen"). Nur gelesen, nie gefiltert. */
  var RE_QLUMEN = /(?:^|[^0-9.,])(\d{2,6})\s*(?:lm|lumen)(?:$|[^a-z0-9])/;

  /* Roehrenkontext: Nur dort gilt die Runde-2-Wattstaffel (Ersatzleistung ist
     bei Roehren laengen-/systemkritisch). G13/G5/2GX13 sind reine
     Roehrensockel; die Wortliste entspricht der kuratierten Familienerkennung. */
  var RE_ROEHRE = /(?:^|[^a-z0-9])(?:g13|g5|2gx13|t8|t5|t12|tl|tld|tl5|roehren?|leuchtstoffroehren?|leuchtroehren?|neonroehren?|tubes?|ledtube|substitube)(?:$|[^0-9])/;

  /* Abstrahlwinkel der Query (Chris 2026-08-13, Kollegen-Fall "GU10 50W 927
     120°"): "120°", "120 °", "120 Grad", "120grad". Der Wert entspricht dem
     Collection-Filter specs.beam_angle (ganzzahlig, z. B. 25/36/60/120). */
  var RE_QBEAM = /(?:^|[^0-9])(\d{1,3})\s*(?:°|grad(?![a-z]))(?![a-z0-9])/;

  /* Ersatzleistungs-KLASSEN — deckungsgleich mit den Gruppen des Leuchtmittel-
     Finder-Filterblocks der Collections (gemessen 2026-08-13 an der GU10-
     Collection): "bis 30 W" = 10-30 · "~35 W" = 32-39 · "~45 W" = 40-49 ·
     "~50 W" = 50-55 · "~80 W" = 60-80 · "90 W+" = ab 90. Ein LED-Spot
     "ersetzt 51 W" gehoert fachlich zur 50-W-Anfrage (Chris Phase 12).
     Gilt NUR ausserhalb des Roehrenkontexts — bei Roehren ist die Ersatz-
     leistung laengen-/systemkritisch und bleibt exakt (18W-Roehre != 25W). */
  var ERSATZ_KLASSEN = [[10, 30], [32, 39], [40, 49], [50, 55], [60, 80], [90, 120]];

  function ersatzKlasse(watt) {
    var w = Number(watt);
    if (!isFinite(w)) return null;
    for (var i = 0; i < ERSATZ_KLASSEN.length; i++) {
      if (w >= ERSATZ_KLASSEN[i][0] && w <= ERSATZ_KLASSEN[i][1]) return ERSATZ_KLASSEN[i];
    }
    return null;
  }

  /* Artikelnummer/EAN: >= 6 zusammenhaengende Ziffern, die KEIN Farbcode und
     keine Laengenangabe sind. */
  var RE_IDENT = /\b\d{6,}\b/g;

  /* Sichere ZERLEGUNG kompakter technischer Schreibweisen (Korrekturrunde 3,
     Chris Phase 5). Deterministisch, keine Fuzzy-Suche: Ziffern werden niemals
     veraendert, hinzugefuegt oder entfernt — es werden ausschliesslich
     Trennstellen zwischen fachlich eindeutigen Tokens eingefuegt bzw. sichere
     Schreibvarianten vereinheitlicht. Belegte Fehlerfaelle aus dem Breitenaudit
     vom 04.08.2026: "13w840" (Watt ungelesen, 0 native Treffer), "l36w 840",
     "hns-15w-g13" (Bindestriche blockieren RE_QWATT), "g 9 2,6 w". */
  function zerlege(text) {
    var s = klein(text);
    var kompakt = /[⁰¹²³⁴⁵⁶⁷⁸⁹₀₁₂₃₄₅₆₇₈₉]/.test(String(text));
    var typo = typoNormalisieren(s);
    if (typo !== s) { kompakt = true; s = typo; }
    var vorher = String(s).replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
    /* Tausender-Kelvin zusammenziehen: "2.700 K" / "2,700 Kelvin" -> "2700 K".
       Nur exakt 1 Ziffer + Trenner + 3 Ziffern direkt vor K — eine
       Dezimalzahl ("2,7 K") bleibt unangetastet. */
    s = s.replace(/(^|[^0-9])([1-9])[.,](\d{3})(\s*k(?:elvin)?)(?=$|[^a-z0-9])/g, '$1$2$3$4');
    /* Bindestrich/Schraegstrich zwischen Wort- und Zifferntoken wird Trenner;
       ZIFFER-ZIFFER bleibt erhalten ("7-16w" ist ein Bereich, keine Liste). */
    s = s.replace(/([a-z])[\-\/]+(\d)/g, function (m, a, b, offset, all) {
      if (/(?:g24[qd]|gx24[qd])$/.test(all.slice(0, offset + 1)) && m.indexOf('-') !== -1) return m;
      return a + ' ' + b;
    });
    s = s.replace(/(\d)[\-\/]+([a-z])/g, '$1 $2');
    s = s.replace(/([a-z])[\-\/]+([a-z])/g, '$1 $2');
    /* Sockelzeichen und Zahl zusammenfuehren: "g 9" -> "g9", "gu 10" -> "gu10". */
    s = s.replace(/(^|[^a-z0-9])(2?g[uxyzr]?)\s+(\d{1,2})(?=$|[^0-9])/g, '$1$2$3');
    /* Dezimalkomma vereinheitlichen — nur ZWISCHEN Ziffern. */
    s = s.replace(/(\d)\s*,\s*(\d)/g, '$1.$2');
    var form = s.replace(/(^|[^a-z0-9])(t5|t8|t9|t12)([a-z]+)(?=\s*\d)/g, '$1$2 $3')
      .replace(/(^|[^a-z0-9])(osram|philips|ledvance|radium|sylvania|megaman)(?=(?:led(?:star|tube|lamp\w*|roehr\w*|spot\w*|fluter\w*|panel\w*)?|dulux\w*|lumilux|parathom|substitube|corepro|master|halolux|halopin|haloline|decostar|halostar|star|value|performance|classic)\b)/g, '$1$2 ')
      .replace(/\bledstar\b/g, 'led star');
    if (form !== s) { kompakt = true; s = form; }
    /* Watt+Farbcode zusammengeklebt: "13w840" -> "13w 840". */
    var s2 = s.replace(new RegExp('(\\d{1,3}(?:\\.\\d)?)\\s*w(' + FARB + ')(?![0-9])', 'g'), '$1w $2');
    if (s2 !== s) { kompakt = true; s = s2; }
    /* Farbcode+Sockelrest: "840g13" -> "840 g13", "827e14" -> "827 e14". */
    s2 = s.replace(new RegExp('(^|[^0-9])(' + FARB + ')([a-z]+\\d)', 'g'), '$1$2 $3');
    if (s2 !== s) { kompakt = true; s = s2; }
    /* Serienbuchstabe+Watt: "l36w" -> "l 36w" (Osram-L-/T-Nomenklatur).
       Bewusst NUR l/t — andere Buchstaben (w5w der Fahrzeuglampen!) bleiben. */
    s2 = s.replace(/(^|[^a-z0-9])([lt])(\d{1,3}(?:\.\d)?w)(?=$|[^a-z0-9])/g, '$1$2 $3');
    if (s2 !== s) { kompakt = true; s = s2; }
    /* Lost decimal in a replacement pair, only directly before a colour code. */
    s2 = s.replace(/\b([1-9])(\d)\s+(\d{2,3})\s*w(?=\s*[\/]?\s*[89](?:2[257]|3[035]|40|5[07]|6[05])\b)/g, function (m, a, b, w) {
      return Number(w) >= 20 && Number(w) <= 150 && Number(a + '.' + b) * 4 <= Number(w) ? a + '.' + b + '-' + w + 'w' : m;
    });
    if (s2 !== s) { kompakt = true; s = s2; }
    s = s.replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
    return { text: s, kompakt: kompakt, veraendert: s !== vorher };
  }

  var RE_GERAET_QUERY = /\b(?:treiber|trafos?|transformator\w*|netzteile?|drivers?|vorschaltgeraete?|evg|kvg|vvg|starter|dimmer|leuchten?|deckenleuchten?|fluter|panels?|sensor|notlicht)\b/;
  var RE_KONVENTIONELL = /\b(?:backofen\w*|ofen\w*|kuehlschrank\w*|naehmaschine\w*|salzlampe\w*|infrarot\w*|halogen\w*|halopin|haloline|halostar|decostar|halolux|dulux\w*|lumilux|leuchtstoff\w*|fluorescent|incandescent|hid|tuv|hns|hqi|hql|cdm\w*|nav|son|entladung\w*)\b/;

  function expliziteErsatzleistung(text) {
    // Two stated powers connected by a replacement word are independent of word order.
    var werte = [], muster = /\b(\d{1,3}(?:[.,]\d)?)\s*w(?:att)?\b/g, treffer;
    while ((treffer = muster.exec(text))) werte.push({ watt: zahl(treffer[1]), start: treffer.index, end: muster.lastIndex });
    if (werte.length === 2 && werte[0].watt !== werte[1].watt
        && /\b(?:ersetzt|ersatz|statt|anstelle|entspricht)\b/.test(text.slice(werte[0].end, werte[1].start))) {
      return { watt: Math.max(werte[0].watt, werte[1].watt), wattEigen: Math.min(werte[0].watt, werte[1].watt) };
    }
    var paar = /\b(\d{1,3}(?:[.,]\d)?)\s*w(?:att)?\s*(?:ersetzt\s*(?:durch)?|ersatz\s*(?:fuer)?|statt|anstelle\s*(?:von)?|entspricht)\s*(\d{1,3}(?:[.,]\d)?)\s*w(?:att)?\b/.exec(text);
    if (paar && zahl(paar[1]) !== zahl(paar[2])) {
      return { watt: Math.max(zahl(paar[1]), zahl(paar[2])), wattEigen: Math.min(zahl(paar[1]), zahl(paar[2])) };
    }
    var vor = /\b(?:ersetzt|ersatz\s*(?:fuer)?|statt|anstelle\s*(?:von)?|entspricht)\s*(\d{1,3}(?:[.,]\d)?)\s*w(?:att)?\b/.exec(text);
    var nach = /\b(\d{1,3}(?:[.,]\d)?)\s*w(?:att)?\s*(?:ersatz|statt|ersetzt\s*durch)\b/.exec(text);
    var bindung = nach || vor;
    if (!bindung) return null;
    var rest = text.slice(0, bindung.index) + ' ' + text.slice(bindung.index + bindung[0].length);
    var eigen = rest.match(/\b(\d{1,3}(?:[.,]\d)?)\s*w(?:att)?\b/g) || [];
    return { watt: zahl(bindung[1]), wattEigen: eigen.length === 1 ? zahl(eigen[0].match(/[\d.,]+/)[0]) : null };
  }

  function lengthComparator(text) {
    text = klein(text);
    var op = '(?:\\b(?:laenger|kuerzer|groesser|kleiner|mehr|weniger)\\s+als\\b|\\b(?:ueber|unter|maximal|mindestens|hoechstens|bis|ab)\\b|\\b(?:max|min)\\b\\.?|[<>]=?|[≤≥])';
    var value = '\\d+(?:[.,]\\d+)?';
    if (new RegExp(op + '\\s*(?:laenge\\s*[:=]?\\s*)?' + value + '\\s*(?:mm|cm|m(?:eter|etre)?)\\b').test(text)) return true;
    if (new RegExp('\\blaenge\\s*[:=]?\\s*' + op + '\\s*' + value + '(?![\\d.,])(?:\\s*(?:mm|cm|m)\\b|(?=\\s*(?:$|[;,])))').test(text)) return true;
    return /\b(?:r7s|halogenstab|stablampe)\b/.test(text)
      && new RegExp(op + '\\s*(?:78|118|114)\\b(?!\\s*(?:lm|lumen|w(?:att)?|k(?:elvin)?|v(?:olt)?|grad|stueck)\\b)').test(text);
  }

  function normQuery(query) {
    return klein(query).replace(/\s+/g, ' ').trim();
  }

  // Only this 32-bit FNV-1a value may cross the sessionStorage boundary.
  function hashQuery(query) {
    var text = normQuery(query), hash = 2166136261;
    for (var i = 0; i < text.length; i++) {
      hash = Math.imul(hash ^ text.charCodeAt(i), 16777619);
    }
    return ('00000000' + (hash >>> 0).toString(16)).slice(-8);
  }

  function wattModus(spec, text) {
    if (spec.wattBereich) return 'direct';
    if (spec.watt === null) return 'none';
    var effSockel = spec.sockel || spec.sockelFallback;
    if (spec.ersatzAbsichtStark || spec.wattEigen !== null) return 'replaces';
    var geraetText = spec.roehrenKontext || spec.ersatzAbsichtStark ? text.replace(/\b(?:evg|kvg|vvg)\b/g, '') : text;
    if (RE_GERAET_QUERY.test(geraetText)
        || (!effSockel && !spec.roehrenKontext && RE_LEUCHTE_QUERY.test(text))) return 'actual';
    var w = spec.watt;
    var konventionell = RE_KONVENTIONELL.test(text);
    if (konventionell && !spec.ersatzAbsichtStark) return 'actual';
    if (/(?:^|\s)\d{1,2}(?:[.,]\d)?\s+\d{2,3}\s*w\b/.test(text)) return 'replaces';
    if (spec.lumen !== null && w > 0 && spec.lumen / w >= 45) return 'actual';
    if (!konventionell && spec.lumen !== null && w >= 25 && spec.lumen / w <= 22
        && /\b(?:led|ledvance|philips|osram)\b/.test(text)) return 'replaces';
    if (spec.roehrenKontext) {
      var klassisch = [14,15,18,21,24,28,30,35,36,38,49,54,58,70,80];
      var ledEigen = [7,7.5,8,9,10,10.5,11,12,12.5,14.5,14.7,15.5,16,16.5,17.5,18.2,19,20,22,23,25,26,27];
      var ledSerie = /\b(?:(?:master|corepro)\s+led(?:tube|\s+(?:tube|roehre))|substitube)\b/.test(text);
      if (ledSerie && ledEigen.indexOf(w) !== -1) return 'actual';
      return /\bled\b|\bledtube\b|\bsubstitube\b/.test(text) && klassisch.indexOf(w) !== -1 ? 'replaces' : 'actual';
    }
    if (konventionell) return 'actual';
    var kleinSockel = ['e14','gu10','gu5.3','g9','g4','gy6.35','b22d'].indexOf(effSockel) !== -1;
    var form = /\b(?:gluehbirne|gluehlampe|birne|kerze|kerzenform|kerzenlampe|tropfen|globe|filament|edison|classic|parathom|ledstar|led star|superstar|corepro|warmglow)\b/.test(text);
    var klassischerWert = (kleinSockel && w >= 20 && w <= 100)
      || ((effSockel === 'e27' || (!effSockel && form)) && [25,35,40,50,60,75,100,120,150,200].indexOf(Math.round(w)) !== -1);
    if (klassischerWert) {
      if (effSockel === 'gu10') return 'replaces';
      if (/\b(?:led|ledstar|led star|parathom|substitube|corepro|master\s*led|classic\s*[abp]\s*\d+|filament|retrofit|superstar|warmglow)\b/.test(text)) return 'replaces';
      if ((spec.farbcode || spec.kelvin !== null) && ['gu10','e14','e27','b22d','g9','gu5.3'].indexOf(effSockel) !== -1) return 'replaces';
      if (!spec.farbcode && spec.kelvin === null) return 'ambiguous';
    }
    return 'actual';
  }

  function parse(query) {
    var roh = klein(query);
    var z = zerlege(query);
    var text = z.text;
    var spec = {
      original: String(query == null ? '' : query),
      normalisiert: text,
      watt: null,
      wattEigen: null,
      wattModus: 'none',
      lengthComparator: false,
      wattBereich: null,
      farbcode: null,
      sockel: null,
      sockelFallback: null,
      dimmbar: null,
      laenge: null,
      kelvin: null,
      lumen: null,
      beam: null,
      ersatzAbsicht: RE_ERSATZ.test(text),
      ersatzAbsichtStark: RE_ERSATZ_STARK.test(text),
      leuchteGesucht: RE_LEUCHTE_QUERY.test(text),
      roehrenKontext: RE_ROEHRE.test(text),
      identifier: (String(query || '').match(RE_IDENT) || []),
      technisch: false
    };
    var explicit = expliziteErsatzleistung(text);
    var m;
    if (explicit) {
      spec.watt = explicit.watt; spec.wattEigen = explicit.wattEigen;
      spec.ersatzAbsichtStark = true;
    } else if ((m = RE_QBEREICH.exec(text))) {
      if (!RE_GERAET_QUERY.test(text) && !RE_LEUCHTE_QUERY.test(text) && !RE_KONVENTIONELL.test(text)
          && zahl(m[1]) < 15 && zahl(m[2]) >= 20 && zahl(m[2]) >= zahl(m[1]) * 3) {
        spec.wattEigen = zahl(m[1]); spec.watt = zahl(m[2]);
      } else {
        spec.wattBereich = [zahl(m[1]), zahl(m[2])];
      }
    } else if ((m = RE_QWATT.exec(text))) {
      spec.watt = zahl(m[1]);
    }
    if ((m = RE_FARB.exec(text))) spec.farbcode = m[1];
    spec.sockel = findeSockel(text, true);
    spec.sockelFallback = spec.sockel ? null : findeSockel(text);
    var dimmText = text.replace(/[-/]+/g, ' ');
    if (/\b(?:(?:nicht|non|not|ohne)\s*dimm(?:bar\w*|able|en)?|undimmable)\b/.test(dimmText)) spec.dimmbar = false;
    else if (/\bdimm(?:bar\w*|able|en)\b/.test(dimmText)) spec.dimmbar = true;
    spec.lengthComparator = lengthComparator(text);
    if (!spec.lengthComparator) {
      if ((m = text.match(/\b([4-9]\d|\d{3,4})\s*mm\b/))) spec.laenge = zahl(m[1]);
      else if ((m = text.match(/\b(\d+(?:[.,]\d+)?)\s*cm\b/))) spec.laenge = Math.round(zahl(m[1]) * 10);
      else if ((m = text.match(/\b(\d+(?:[.,]\d+)?)\s*m(?:eter|etre)?\b/))) spec.laenge = Math.round(zahl(m[1]) * 1000);
      else if (/\b(?:r7s|halogenstab|stablampe)\b/.test(text) && (m = text.match(/\b(78|118|114)\b(?!\s*(?:lm|w|k)\b)/))) spec.laenge = zahl(m[1]);
    }
    if ((m = RE_QKELVIN.exec(text))) spec.kelvin = zahl(m[1]);
    else if (/\b(?:kalt\s*weiss|neutral\s*weiss|cool white)\b/.test(text)) spec.kelvin = 4000;
    else if (/\b(?:tageslicht\s*weiss|tageslicht|daylight)\b/.test(text)) spec.kelvin = 6500;
    if ((m = RE_QLUMEN.exec(text))) spec.lumen = zahl(m[1]);
    if ((m = RE_QBEAM.exec(text))) spec.beam = zahl(m[1]);
    /* KORREKTURRUNDE 4: "osram 13w 850 lm" — die 850 ist der LICHTSTROM, kein
       Lichtfarbcode. Traegt dieselbe Zahl die lm-Einheit, ist die Farbcode-
       Lesung ein Fehltreffer und wird verworfen ("13W/850 830lm" bleibt, weil
       dort zwei verschiedene Zahlen stehen). */
    if (spec.farbcode && spec.lumen !== null
        && String(spec.farbcode) === String(Math.round(spec.lumen))
        && new RegExp('(?:^|[^0-9])' + spec.farbcode + '\\s*(?:lm|lumen)').test(text)
        && !new RegExp('(?:^|[^0-9])' + spec.farbcode + '(?![0-9\\s]*(?:lm|lumen))(?:$|[^0-9])').test(text)) {
      spec.farbcode = null;
    }
    spec.wattModus = wattModus(spec, text);
    spec.ersatzPrimaer = spec.wattModus === 'replaces';

    /* "Technisch" heisst: mindestens ZWEI strukturierte Werte. Ein einzelnes
       "G13" oder "18W" bleibt eine breite Kategoriesuche und wird nicht
       eingeengt — das ist Absicht.
       Ausnahme: Wattangabe + ausdrueckliches Ersatzwort ("ersetzt 16W") ist
       eindeutig strukturiert, auch wenn Farbcode und Sockel fehlen. */
    var werte = 0;
    if (spec.watt !== null) werte += 1;
    if (spec.farbcode) werte += 1;
    if (spec.sockel) werte += 1;
    if (spec.laenge) werte += 1;
    if (spec.kelvin !== null) werte += 1;
    if (spec.beam !== null) werte += 1;
    if (spec.lumen !== null) werte += 1;
    spec.technisch = (werte >= 2 || (spec.watt !== null && spec.ersatzAbsichtStark))
      && spec.identifier.length === 0;
    return spec;
  }

  /* Kanonische Schreibweise fuer die ERGAENZENDE native Suche. Liefert nur dann
     einen Wert, wenn die Zerlegung ein kompaktes Muster aufgeloest hat oder
     danach mehr technische Werte lesbar sind als vorher — sonst bleibt die
     native Anfrage byteidentisch. Identifier-Anfragen sind ausgeschlossen.
     Die SICHTBARE Kundeneingabe wird nie veraendert. */
  function wertZahl(text) {
    var n = 0;
    if (RE_QWATT.test(text) || RE_QBEREICH.test(text)) n += 1;
    if (RE_FARB.test(text)) n += 1;
    if (findeSockel(text)) n += 1;
    if (RE_QKELVIN.test(text)) n += 1;
    return n;
  }

  function kanonischeQuery(query) {
    var roh = klein(query);
    if ((String(query || '').match(RE_IDENT) || []).length) return null;
    var z = zerlege(query);
    if (z.kompakt) return z.text;
    if (!z.veraendert) return null;
    return wertZahl(z.text) > wertZahl(roh) ? z.text : null;
  }

  /* ------------------------------------------------- Titel-Tokenisierung (§6) */
  /* Ein Wattwert im Titel ist NICHT automatisch die tatsaechliche Leistung:
       "16W/840"     -> tatsaechlich 16
       "7-16W/840"   -> tatsaechlich  7, ersetzt 16   (LED-Retrofit fuer 16 W)
       "16-36W/840"  -> tatsaechlich 16, ersetzt 36   (16-W-LED fuer 36-W-Roehre)
     Bei "a-bW" ist immer a die echte Leistung und b die ersetzte — das deckt
     sich mit den Metafeldern (7,0/16,0 bzw. 16,0/36,0) und ist an beiden
     Vergleichsprodukten geprueft. */
  var RE_PAAR = new RegExp(
    '(?:^|[^0-9.,])(?:(\\d{1,3}(?:[.,]\\d)?)\\s*-\\s*)?(\\d{1,3}(?:[.,]\\d)?)\\s*w\\s*[\\/\\-\\s]\\s*(' + FARB + ')(?:$|[^0-9])',
    'g');
  var RE_TWATT = /(?:^|[^0-9.,])(?:(\d{1,3}(?:[.,]\d)?)\s*-\s*)?(\d{1,3}(?:[.,]\d)?)\s*w(?:$|[^a-z0-9])/g;

  function titelWerte(titel) {
    var text = klein(titel);
    var out = { paare: [], istWatt: [], ersatzWatt: [], text: text };
    var m;
    RE_PAAR.lastIndex = 0;
    while ((m = RE_PAAR.exec(text)) !== null) {
      var ist = m[1] ? zahl(m[1]) : zahl(m[2]);
      var ers = m[1] ? zahl(m[2]) : null;
      out.paare.push({ ist: ist, ersatz: ers, farbcode: m[3], bereich: !!m[1] });
    }
    RE_TWATT.lastIndex = 0;
    while ((m = RE_TWATT.exec(text)) !== null) {
      var i2 = m[1] ? zahl(m[1]) : zahl(m[2]);
      var e2 = m[1] ? zahl(m[2]) : null;
      if (i2 !== null && out.istWatt.indexOf(i2) === -1) out.istWatt.push(i2);
      if (e2 !== null && out.ersatzWatt.indexOf(e2) === -1) out.ersatzWatt.push(e2);
    }
    return out;
  }

  /* ================================================ TITLE-FIRST (Chris 13.08.2026)
     VERBINDLICHE GRUNDREGEL DER LMM-SUCHE: Steht ein gesuchtes Merkmal EINDEUTIG im
     Artikelnamen, ist dieser Titelwert fuer Suche, Matching und Ranking die fuehrende
     Wahrheit. Metafelder sind Rueckfallebene und greifen NUR, wenn der Titel zu genau
     diesem Merkmal nichts Eindeutiges sagt. Widersprechen sich beide, gewinnt fuer die
     SUCHLOGIK der Titel — die Produktdaten bleiben unangetastet, der Konflikt wird nur
     protokolliert (ein Metafeld kann eine echte Betriebs- oder Systemleistung sein).

     Die Regel gilt MERKMALSWEISE, nicht pauschal: ein Titel darf die Wattzahl liefern
     und den Abstrahlwinkel offenlassen; dann kommt der Winkel weiterhin aus
     specs.beam_angle.

     Diese Funktion ist bewusst KONSERVATIV. Ein Merkmal gilt nur als "eindeutig im
     Titel", wenn es seine Einheit mitbringt (mm · lm · K · ° bzw. Grad · Ra/CRI) und
     im Titel nicht mehrdeutig ist. Blosse Zahlen — Artikelnummern, PAR-Groessen,
     Spannungen, Verpackungseinheiten — werden NIE als Merkmal gelesen. */
  var RE_TKELVIN = /(?:^|[^0-9.,])([1-9]\d{3})\s*k(?:elvin)?(?:$|[^a-z0-9])/;
  var RE_TLUMEN = /(?:^|[^0-9.,])(\d{2,6})\s*(?:lm|lumen)(?:$|[^a-z0-9])/;
  var RE_TLAENGE = /(?:^|[^0-9.,])([4-9]\d|\d{3,4})\s*mm(?:$|[^a-z0-9])/;
  var RE_TBEAM = /(?:^|[^0-9])(\d{1,3})\s*(?:°|grad(?![a-z]))(?![a-z0-9])/;
  var RE_TCRI = /(?:^|[^a-z0-9])(?:ra|cri)\s*[>=]?\s*(\d{2,3})(?:$|[^0-9])/;
  /* BEREICHSSPERREN (Konflikt-Sweep 13.08.2026). Zwei Titelmuster nennen zwei
     Endpunkte statt eines Wertes und duerfen deshalb KEIN Merkmal setzen — sonst
     wuerde ein Endpunkt als exakter Wert gelesen:
       Tunable White "3000-6500K"  (129 Produkte im Katalog)
       Winkelbereich  "41-80°"     (560 Produkte im Katalog)
     In beiden Faellen bleibt das strukturierte Feld zustaendig. */
  var RE_TKELVIN_BEREICH = /\d{3,4}\s*-\s*[1-9]\d{3}\s*k(?:elvin)?(?:$|[^a-z0-9])/;
  var RE_TBEAM_BEREICH = /\d{1,3}\s*-\s*\d{1,3}\s*(?:°|grad(?![a-z]))/;
  /* BETRIEBSGERAETE-SPERRE (Konflikt-Sweep 13.08.2026, Muster R1/R2/R12, 56 Produkte).
     Bei einem Vorschaltgeraet, Treiber, Zuendgeraet oder Starter nennt der Titel die
     Leistung der LAMPE, die das Geraet betreibt — nicht die eigene:
       "QT-FIT8 2x58 fuer 2x58W"  -> Geraet 110 W System, Titel 58 W Lampe
       "HID-PV C 1x35 /G CDM"     -> Titelzahl ist die Lampenleistung
     Ein EINZELNER Wattwert im Titel darf dort deshalb nicht als Eigenleistung gelten;
     specs.wattage bleibt zustaendig. Die Paar-Schreibweise MIT Farbcode ("7-16W/840")
     ist davon ausgenommen — sie kommt nur bei Lampen vor, und Hinweise wie "KVG" im
     Lampentitel sind Betriebsart-Angaben, keine Geraeteklassen. */
  var RE_GERAET_TITEL = /vorschaltgeraet\w*|betriebsgeraet\w*|zuendgeraet\w*|\bevg\b|\bkvg\b|\bvvg\b|\btreiber\b|netzteil\w*|\btrafo\b|transformator\w*|\bdriver\b|\bstarter\b|\bdimmer\b|steuergeraet\w*|\bhid-?pv\b|\bhid-?av\b|\bqt-?fit\b|\bqtp?\b/;

  function _einzig(liste) {
    /* genau EIN unterschiedlicher Wert -> eindeutig; sonst null */
    if (!liste || !liste.length) return null;
    for (var i = 1; i < liste.length; i++) if (liste[i] !== liste[0]) return null;
    return liste[0];
  }

  function titelMerkmale(titel) {
    var text = klein(titel || '');
    var tw = titelWerte(titel || '');
    var out = { watt: null, ersatzWatt: null, farbcode: null, kelvin: null,
                lumen: null, laenge: null, beam: null, cri: null, sockel: null };

    /* WATT. Hoechste Sicherheit hat das Paar mit Farbcode ("70W/830", "5,5-50W/927"):
       dort ist die Hausschreibweise eindeutig — a = Eigenleistung, b = ersetzte
       Leistung. Ein Wattbereich OHNE Farbcode ist dagegen mehrdeutig und meint bei
       Geraeten den ABDECKUNGSBEREICH, nicht die Leistung: "Starter … 4-65W",
       "Zuendgeraet … 35-600W", "BodyTone St 120-180W". Solche Bereiche werden
       ausdruecklich NICHT als Wattmerkmal gelesen — dort bleibt das Metafeld
       zustaendig. Ein einzelner Wattwert ohne Bereich ("HALOPAR … 50W GU10") ist
       eindeutig und wird uebernommen. */
    var mitFarbe = [], istListe = [], ersListe = [];
    for (var i = 0; i < tw.paare.length; i++) {
      mitFarbe.push(tw.paare[i]);
      istListe.push(tw.paare[i].ist);
      if (tw.paare[i].ersatz !== null) ersListe.push(tw.paare[i].ersatz);
    }
    if (mitFarbe.length) {
      var ist = _einzig(istListe);
      if (ist !== null) {
        out.watt = ist;
        out.ersatzWatt = ersListe.length ? _einzig(ersListe) : null;
      }
      var codes = [];
      for (var c = 0; c < mitFarbe.length; c++) codes.push(mitFarbe[c].farbcode);
      out.farbcode = _einzig(codes);
    } else if (tw.istWatt.length === 1 && tw.ersatzWatt.length === 0
               && !RE_GERAET_TITEL.test(text)) {
      out.watt = tw.istWatt[0];
    }

    var m;
    if (!RE_TKELVIN_BEREICH.test(text) && (m = RE_TKELVIN.exec(text))) out.kelvin = zahl(m[1]);
    if ((m = RE_TLUMEN.exec(text))) out.lumen = zahl(m[1]);
    if ((m = RE_TLAENGE.exec(text))) out.laenge = zahl(m[1]);
    if (!RE_TBEAM_BEREICH.test(text) && (m = RE_TBEAM.exec(text))) out.beam = zahl(m[1]);
    if ((m = RE_TCRI.exec(text))) out.cri = zahl(m[1]);
    /* Sockel nur bei EINDEUTIGKEIT: Adapter- und Set-Titel nennen zwei Sockel
       ("Adapter G9 auf GU10", 15 Produkte). Dort entscheidet weiterhin specs.base. */
    var s1 = findeSockel(text, true) || null;
    if (s1) {
      var rest = text.replace(new RegExp(s1.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), ' ');
      out.sockel = findeSockel(rest, true) ? null : s1;
    }
    return out;
  }

  /* Merkmalsweise Aufloesung Titel vor Struktur. Liefert den zu verwendenden Wert,
     die Quelle und — rein informativ fuer die QA — ob beide Quellen sich
     widersprechen. Es wird NICHTS an den Produktdaten geaendert. */
  function resolveMerkmal(titelWert, strukturWert, toleranz) {
    var t = (titelWert === undefined || titelWert === null || titelWert === '') ? null : titelWert;
    var s = (strukturWert === undefined || strukturWert === null || strukturWert === '') ? null : strukturWert;
    if (t === null) return { wert: s, quelle: s === null ? 'unbekannt' : 'struktur', konflikt: false };
    var konflikt = false;
    if (s !== null) {
      var tn = Number(t), sn = Number(s);
      if (isFinite(tn) && isFinite(sn)) konflikt = Math.abs(tn - sn) > (toleranz || 0);
      else konflikt = String(t).toLowerCase() !== String(s).toLowerCase();
    }
    return { wert: t, quelle: 'titel', konflikt: konflikt };
  }

  /* ------------------------------------------------- Klassifizierung (§1, §3, §4) */
  /* Kleinere Klasse = fachlich genauer. Bezeichnungen bewusst sprechend, damit
     sie im DOM (data-lmm-tech-why) nachvollziehbar sind. */
  var KLASSE = {
    identifier: 0,
    titelExakt: 1,
    attributExakt: 2,
    attributTeil: 3,
    ersatz: 4,
    sonstiges: 5
  };

  function gleich(a, b) {
    if (a === null || a === undefined || b === null || b === undefined) return false;
    return Math.abs(Number(a) - Number(b)) < 0.05;
  }

  function sockelPasst(spec, attrBase, titelText) {
    if (!spec.sockel) return true;
    if (attrBase) return sockelImText(spec.sockel, attrBase);
    return sockelImText(spec.sockel, titelText);
  }

  /* Ist das Produkt eine komplette LEUCHTE? Quelle ist der Produkttyp bzw. der
     Bucket des Suchklassifizierers (snippets/lmm-search-classify) — nie der
     Titel, damit "Leuchtstoffroehre" nicht faelschlich als Leuchte gilt.
     "leuchtstoffroehren" trifft die Wortgrenze nicht, "leuchten" schon. */
  function istLeuchte(typ, bucket) {
    var text = klein(typ || '') + ' ' + klein(bucket || '');
    return /\bleuchten?\b/.test(text) || /luminaire/.test(text);
  }

  /* Nennt der ARTIKELNAME ausdrueckliche Wattwerte — aber keinen davon in der
     gesuchten Stufe? Dann ist ein passendes Wattmetafeld fachlich nicht der
     gesuchte Wert. Belegter Fall (Chris 2026-07-30):
       "LEDVANCE LED Feuchtraumleuchte Submarine 600 2-flammig inkl. 2x8W/840"
       traegt specs.wattage = 16,0 — das ist die SUMME aus 2 x 8 W. Im
       Artikelnamen steht 8W. Fuer die Suche "16W/840" ist das kein Treffer.
     Bereiche zaehlen mit: "16-36W/840" enthaelt die 16 (tatsaechliche Leistung),
     "7-16W/840" enthaelt sie als ersetzte Leistung — beide bleiben drin und
     werden weiter unten nach ihrer Klasse einsortiert. */
  function titelWattWiderspruch(titel, wattZiel) {
    if (wattZiel === null || wattZiel === undefined) return false;
    var alle = titel.istWatt.concat(titel.ersatzWatt);
    if (!alle.length) return false;
    for (var i = 0; i < alle.length; i++) {
      if (gleich(alle[i], wattZiel)) return false;
    }
    return true;
  }

  function sockelWiderspruch(spec, attrBase, titelText) {
    if (!spec.sockel) return false;
    if (sockelPasst(spec, attrBase, titelText)) return false;
    /* Nur widerspruechlich, wenn ueberhaupt ein anderer Sockel erkennbar ist. */
    var anderer = findeSockel(attrBase ? klein(attrBase) : titelText);
    return !!anderer && anderer !== spec.sockel;
  }

  /* p: { titel, watt, ersatzWatt, sockel, farbcode, kaufbar }
     watt/ersatzWatt/sockel/farbcode duerfen fehlen — dann entscheidet der Titel. */
  function classify(spec, p) {
    var titel = titelWerte(p && p.titel);
    var aWatt = p && p.watt !== undefined && p.watt !== null && p.watt !== '' ? zahl(p.watt) : null;
    var aErs = p && p.ersatzWatt !== undefined && p.ersatzWatt !== null && p.ersatzWatt !== ''
      ? zahl(p.ersatzWatt) : null;
    var aFarb = p && p.farbcode ? String(p.farbcode).trim() : null;
    var aBase = p && p.sockel ? String(p.sockel) : null;

    if (spec.identifier.length) {
      for (var i = 0; i < spec.identifier.length; i++) {
        if (titel.text.indexOf(spec.identifier[i]) !== -1) {
          return { klasse: KLASSE.identifier, grund: 'identifier' };
        }
      }
    }

    var wattZiel = spec.watt;
    var farbZiel = spec.farbcode;

    var leuchte = istLeuchte(p && p.typ, p && p.bucket);

    /* ---- Ausschluss 1 (Chris 2026-07-30, zweite Runde): Titel-Wattwiderspruch.
       "Der Artikelname ist die genaueste Quelle." Nennt er ausdrueckliche
       Wattwerte, aber nicht die gesuchte Stufe, ist ein passendes Wattmetafeld
       fachlich nicht der gesuchte Wert (2 x 8 W ist keine 16-W-Lichtquelle).
       Ausnahme: Sucht die Query ausdruecklich eine LEUCHTE, ist die
       Systemleistung der gemeinte Wert — eine "Feuchtraumleuchte 16W" ist eine
       zweiflammige 2-x-8-W-Leuchte. Dann bleibt das Metafeld massgeblich. */
    /* ---- AUSNAHME ZU AUSSCHLUSS 1 (Chris 2026-08-11): Bei ERSATZ-Leseart ist
       die ERSETZTE Leistung der gesuchte Wattbezug, nicht die Eigenleistung.
       Traegt das Produkt das strukturierte Feld specs.replaces_wattage in genau
       der gesuchten Stufe, ist eine abweichende Eigenleistung im Titel KEIN
       Widerspruch, sondern die Bauart eines Retrofits.
       Belegter Fall (read-only am 2026-08-11 gemessen, Canary 203799626065,
       q="18W Leuchtstoffroehre durch LED ersetzen" — ALLE vier Produkte tragen
       specs.replaces_wattage = 18,0 und specs.base = G13):
         "… A-Serie Roehre 270° 10-18W/860 …"   -> ersatzwattage          (4)
         "… VLE 0.6M HO Glas 8-18W/840 G13 …"   -> ersatzwattage          (4)
         "… MASTER LEDtube HO 8W/865 LED T8 …"  -> titel-watt-widerspruch (5)
         "… CorePro LEDtube UN 600mm 8W/840 …"  -> titel-watt-widerspruch (5)
       Es entschied allein die SCHREIBWEISE des Lieferantentitels ("8-18W" statt
       "8W"), ob dieselbe verifizierte 18-W-Ersatzbeziehung als Treffer oder als
       fachlicher Widerspruch galt. Die 8 W sind die Eigenleistung der LED und
       stehen der verifizierten Ersatzleistung 18 W nicht entgegen.
       BELEG ist ausschliesslich das METAFELD: aus einem Titel wie "8-18W" wird
       hier KEINE Ersatzbeziehung hergeleitet, und fehlt das Feld, bleibt es beim
       bisherigen Ausschluss — es wird keine Ersatzbeziehung erfunden.
       Ohne Ersatz-Leseart greift die Ausnahme nicht: "18W E27" sucht weiterhin
       18 W EIGENleistung, eine 8-W-Lampe bleibt dort ausgeschlossen.
       spec.ersatzPrimaer ist bewusst dieselbe Bedingung, die weiter unten
       ersatzFilterParams() auf specs.replaces_wattage umschaltet — es waere
       widerspruechlich, den Kandidatensatz nach replaces_wattage zu VERENGEN und
       genau diese Kandidaten anschliessend als Widerspruch einzustufen. */
    var ersatzBelegt = spec.ersatzPrimaer && wattZiel !== null && gleich(aErs, wattZiel);
    if (!(spec.leuchteGesucht && leuchte) && !ersatzBelegt
        && titelWattWiderspruch(titel, wattZiel)) {
      return { klasse: KLASSE.sonstiges, grund: 'titel-watt-widerspruch' };
    }

    /* ---- Ausschluss 2: Eine Sockelbezeichnung in der Query bezeichnet ein
       LEUCHTMITTEL. Wer "16W/840 G13" sucht, sucht eine Roehre — keine
       Feuchtraumleuchte, auch dann nicht, wenn diese G13-Roehren enthaelt und
       deshalb specs.base = G13 traegt (live so gemessen). Nennt die Query
       selbst eine Leuchte ("Feuchtraumleuchte 4000K"), greift der Ausschluss
       nicht. */
    if (spec.sockel && !spec.leuchteGesucht && leuchte) {
      return { klasse: KLASSE.sonstiges, grund: 'leuchte-statt-leuchtmittel' };
    }

    /* Aus dem Titel abgeleitete Werte als Rueckfallebene, wenn keine Metafelder
       am Element haengen (Header-Dropdown rendert nur den Titel). */
    var istWatt = aWatt !== null ? aWatt : (titel.paare.length ? titel.paare[0].ist
      : (titel.istWatt.length ? titel.istWatt[0] : null));
    var ersWatt = aErs !== null ? aErs : (titel.paare.length ? titel.paare[0].ersatz
      : (titel.ersatzWatt.length ? titel.ersatzWatt[0] : null));
    var farbe = aFarb || (titel.paare.length ? titel.paare[0].farbcode : null);

    var wattTrifft = wattZiel === null || gleich(istWatt, wattZiel);
    var wattErsatz = wattZiel !== null && (gleich(ersWatt, wattZiel)
      || titel.ersatzWatt.some(function (w) { return gleich(w, wattZiel); }));
    var farbTrifft = !farbZiel || (farbe && String(farbe) === String(farbZiel));
    var farbBekannt = !!farbe;
    var baseTrifft = sockelPasst(spec, aBase, titel.text);

    /* Stufe A — exakte, ZUSAMMENHAENGENDE Titelphrase: "16W/840" steht so im
       Titel, und die 16 ist dort die tatsaechliche Leistung (kein Bereich).
       "16-36W/840" erfuellt das bewusst NICHT: dort steht nicht "16W/840". */
    if (wattZiel !== null && farbZiel && baseTrifft) {
      for (var j = 0; j < titel.paare.length; j++) {
        var paar = titel.paare[j];
        if (!paar.bereich && gleich(paar.ist, wattZiel) && String(paar.farbcode) === String(farbZiel)) {
          return { klasse: KLASSE.titelExakt, grund: 'titelphrase' };
        }
      }
    }

    /* Stufe B — alle gesuchten TATSAECHLICHEN Attribute exakt. */
    if (wattZiel !== null && gleich(istWatt, wattZiel) && farbTrifft && baseTrifft
        && (!farbZiel || farbBekannt)) {
      return { klasse: KLASSE.attributExakt, grund: 'attribute-exakt' };
    }

    /* Stufe C — tatsaechliche Wattage exakt, ein weiterer Wert fehlt (nicht:
       widerspricht). Fehlende Daten sind eine Datenluecke, kein Ausschluss. */
    if (wattZiel !== null && gleich(istWatt, wattZiel)
        && !sockelWiderspruch(spec, aBase, titel.text)
        && (farbTrifft || !farbBekannt)) {
      return { klasse: KLASSE.attributTeil, grund: 'wattage-exakt-teilweise' };
    }

    /* Stufe D — Ersatz-/Kompatibilitaetstreffer: die gesuchte Wattage steht nur
       als ERSETZTE Leistung. Ohne Ersatzabsicht bleibt das nachrangig. */
    if (wattErsatz && farbTrifft && baseTrifft) {
      return { klasse: KLASSE.ersatz, grund: 'ersatzwattage' };
    }

    /* Ohne Wattangabe in der Query traegt Farbe+Sockel die Genauigkeit. */
    if (wattZiel === null && farbZiel && farbTrifft && baseTrifft) {
      return { klasse: KLASSE.attributExakt, grund: 'farbe-sockel-exakt' };
    }

    return { klasse: KLASSE.sonstiges, grund: 'kein-technischer-treffer' };
  }

  /* Bei ausdruecklicher Ersatzabsicht — oder "LED" im Roehrenkontext — wandert
     der Ersatztreffer nach vorn (Chris §4; verschaerft in Korrekturrunde 3:
     ein blosses "LED 6W E27" ist KEINE Ersatzsuche mehr, die tatsaechliche
     Eigenleistung bleibt vorn). Die Klassen selbst bleiben unveraendert. */
  function gewicht(spec, klasse) {
    if (!spec.ersatzPrimaer) return klasse;
    if (klasse === KLASSE.ersatz) return 1;
    if (klasse === KLASSE.titelExakt) return 2;
    if (klasse === KLASSE.attributExakt) return 3;
    if (klasse === KLASSE.attributTeil) return 4;
    return klasse;
  }

  /* ------------------------------------------- strenge Kandidatenstufe (§3, §5) */
  /* Es werden ausschliesslich Filter gesetzt, die
       (a) am 2026-07-30 read-only als WIRKSAM belegt sind und
       (b) von der Suchseite als Aktiv-Chip mit Entfernen-Link GERENDERT werden.
     Bedingung (b) ist keine Kosmetik: ein Filter, den der Kunde nicht sieht und
     nicht wegklicken kann, waere eine heimliche Verengung.

       filter.p.m.specs.wattage           602 -> 11   Chip "16 W ×"        wirksam, sichtbar
       filter.p.m.specs.replaces_wattage 1000 ->  3   Chip "ersetzt 16 W ×" wirksam, sichtbar
       filter.p.m.specs.kelvin            851 -> 564  Chip "4000 K ×"      wirksam, sichtbar

     BEWUSST NICHT verwendet:
       filter.p.m.specs.color_code  wirksam (605 -> 365, 100 % Trefferquote im
         Falsifikationstest), aber die Suchseite rendert dafuer KEINE Facette —
         der Kunde koennte den Filter nicht entfernen. Ersetzt durch Kelvin:
         Farbcode 840 == 4000 K (letzte zwei Ziffern x 100), 1:1 dieselbe Menge.
       filter.p.m.specs.base        WIRKUNGSLOS. Mit ihm bleibt die Trefferzahl
         bei 605 — exakt wie mit einem frei erfundenen Parameter. Der Sockel wird
         deshalb nur in der Rangfolge ausgewertet, nie in der Kandidatenstufe. */
  function wattWert(n) {
    var x = Number(n);
    if (!isFinite(x)) return null;
    return Math.abs(x - Math.round(x)) < 0.001 ? x.toFixed(1) : String(x);
  }

  /* Farbcode -> Kelvin: erste Ziffer = Farbwiedergabe-Band, die beiden letzten
     x 100 = Farbtemperatur. 840 -> 4000, 827 -> 2700, 865 -> 6500, 935 -> 3500. */
  function kelvinAusCode(code) {
    var m = /^[89](\d\d)$/.exec(String(code || ''));
    return m ? String(Number(m[1]) * 100) : null;
  }

  function filterParams(spec) {
    var out = [];
    if (!spec || !spec.technisch) return out;
    if (spec.watt !== null && spec.wattModus !== 'ambiguous') {
      var w = wattWert(spec.watt);
      if (w) out.push([spec.ersatzPrimaer ? 'filter.p.m.specs.replaces_wattage'
        : 'filter.p.m.specs.wattage', w]);
      if (spec.ersatzPrimaer && !spec.roehrenKontext) {
        var kl = ersatzKlasse(spec.watt);
        if (kl) for (var kw = kl[0]; kw <= kl[1]; kw++) {
          if (wattWert(kw) !== w) out.push(['filter.p.m.specs.replaces_wattage', wattWert(kw)]);
        }
      }
    }
    if (spec.farbcode) {
      var k = kelvinAusCode(spec.farbcode);
      if (k) out.push(['filter.p.m.specs.kelvin', k]);
    } else if (spec.kelvin !== null) {
      /* Ausdruecklicher Kelvinwert der Query — derselbe belegte, als Chip
         sichtbare Filter wie beim Farbcode (Korrekturrunde 3, Chris Phase 4). */
      out.push(['filter.p.m.specs.kelvin', String(Math.round(spec.kelvin))]);
    }
    /* Abstrahlwinkel (2026-08-13): specs.beam_angle ist dieselbe Facette wie im
       Collection-Filter, wird auf der Suchseite gerendert und erscheint als
       entfernbarer Aktiv-Chip — erfuellt damit Bedingung (b) oben. */
    if (spec.beam !== null) {
      out.push(['filter.p.m.specs.beam_angle', String(Math.round(spec.beam))]);
    }
    return out;
  }

  /* Folgestufe D als EIGENE Kandidatenstufe (Chris 2026-07-30, zweite Runde).
     Dieselbe Logik, nur auf die ERSETZTE Leistung. Grund: Die strenge Stufe
     filtert auf specs.wattage — eine "LED Tube T8 7-16W/840 G13" traegt dort
     7,0 und faellt deshalb heraus, obwohl sie fachlich naeher an der Anfrage
     liegt als jedes Produkt ohne 16-W-Bezug. Sie wird deshalb in einem
     zweiten, ausdruecklich beschrifteten Schritt nachgeladen und steht per
     Klasse 4 IMMER hinter den exakten Treffern.
     Read-only gemessen: q="16W/840 G13" + replaces_wattage=16.0 + kelvin=4000
     ergibt 3 Treffer (2 x G13, 1 x GR8) — eine kleine, fachlich saubere Menge.
     Bei ausdruecklicher Ersatzabsicht entfaellt die Stufe, weil dann bereits
     die Hauptstufe auf replaces_wattage filtert. */
  function ersatzFilterParams(spec) {
    var out = [];
    if (!spec || !spec.technisch || spec.ersatzPrimaer || spec.watt === null) return out;
    var w = wattWert(spec.watt);
    if (!w) return out;
    out.push(['filter.p.m.specs.replaces_wattage', w]);
    /* Ersatzklasse (Chris Phase 12, 2026-08-13): ausserhalb des Roehrenkontexts
       gehoeren alle Werte der Leuchtmittel-Finder-Klasse zur Anfrage — "50 W"
       laedt auch "ersetzt 51 W"/"ersetzt 55 W" nach (Shopify ODER-verknuepft
       wiederholte Filterwerte). Bei Roehren bleibt der exakte Wert allein. */
    if (!spec.roehrenKontext) {
      var kl = ersatzKlasse(spec.watt);
      if (kl) {
        for (var kw = Math.ceil(kl[0]); kw <= kl[1]; kw += 1) {
          var kws = wattWert(kw);
          if (kws && kws !== w) out.push(['filter.p.m.specs.replaces_wattage', kws]);
        }
      }
    }
    if (spec.farbcode) {
      var k = kelvinAusCode(spec.farbcode);
      if (k) out.push(['filter.p.m.specs.kelvin', k]);
    } else if (spec.kelvin !== null) {
      out.push(['filter.p.m.specs.kelvin', String(Math.round(spec.kelvin))]);
    }
    /* Beam-Angle auch in der Ersatzstufe — sonst laedt sie 36°-Spots zu einer
       ausdruecklichen 120°-Anfrage nach. */
    if (spec.beam !== null) {
      out.push(['filter.p.m.specs.beam_angle', String(Math.round(spec.beam))]);
    }
    return out;
  }

  /* --------------------------------------------------------------- Vergleicher */
  /* technische Exaktheit > Titelgenauigkeit (beides in der Klasse) >
     Verfuegbarkeit > Popularitaet/Serverreihenfolge (vom Aufrufer). */
  function vergleiche(a, b) {
    if (a.gewicht !== b.gewicht) return a.gewicht - b.gewicht;
    var ka = a.kaufbar ? 0 : 1;
    var kb = b.kaufbar ? 0 : 1;
    if (ka !== kb) return ka - kb;
    return 0;
  }

  window.LMMTechRank = {
    version: '2026.08.13-1',
    parse: parse,
    lengthComparator: lengthComparator,
    normQuery: normQuery,
    hashQuery: hashQuery,
    expliziteErsatzleistung: expliziteErsatzleistung,
    zerlege: zerlege,
    istKompaktOderTypo: function (query) { return !(String(query || '').match(RE_IDENT) || []).length && zerlege(query).kompakt; },
    ersatzKlasse: ersatzKlasse,
    findeSockel: findeSockel,
    kanonSockel: kanonSockel,
    sockelImText: sockelImText,
    classify: classify,
    gewicht: gewicht,
    filterParams: filterParams,
    ersatzFilterParams: ersatzFilterParams,
    kanonischeQuery: kanonischeQuery,
    kelvinAusCode: kelvinAusCode,
    titelWerte: titelWerte,
    titelMerkmale: titelMerkmale,
    resolveMerkmal: resolveMerkmal,
    istLeuchte: istLeuchte,
    titelWattWiderspruch: titelWattWiderspruch,
    vergleiche: vergleiche,
    KLASSE: KLASSE
  };
})();

